import { useQueryClient } from "@tanstack/react-query"
import { Modal } from "components/ui/modals/Modal/Modal"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { ButtonWarning } from "components/ui/buttons/ButtonWarning/ButtonWarning"
import { useUpdateModelNumberCategories } from "hooks/api/modelNumbers/modelNumbers.hook"
import { useMessage } from "hooks/message.hook"
import { useApiErrorFormatter } from "hooks/apiErrorFormatter.hook"
import style from "./DetachModal.module.scss"

const { text, buttons } = style

type Props = {
	isModalOpen: boolean
	modelNumberId?: number
	modelNumberName?: string
	onCancel: () => void
	onSuccess?: () => void
}

export const DetachModal = ({ isModalOpen, modelNumberId, modelNumberName, onCancel, onSuccess }: Props) => {
	const queryClient = useQueryClient()
	const { success } = useMessage()
	const { formatError } = useApiErrorFormatter()
	const { mutate: updateModelNumberCategories, isPending: isUpdateModelNumberCategoriesPending } =
		useUpdateModelNumberCategories()

	const onDetachHandle = () => {
		if (!modelNumberId) return

		updateModelNumberCategories(
			{ id: modelNumberId, relatedCategoryId: null },
			{
				onSuccess: () => {
					void Promise.all([
						queryClient.invalidateQueries({ queryKey: ["getModelNumbers"] }),
						queryClient.invalidateQueries({ queryKey: ["getModelNumber", modelNumberId] }),
					])

					onSuccess?.()
					success("Category detached from model number")
					onCancel()
				},
				onError: (e) => {
					formatError(e)
				},
			},
		)
	}

	return (
		<Modal title="Detach model from category" isModalOpen={isModalOpen} setModalClose={onCancel} width={456}>
			<p className={text}>
				Are you sure you want to detach model <span>{modelNumberName ?? ""}</span> from these categories?
			</p>
			<div className={buttons}>
				<ButtonSecondary onClick={onCancel}>Cancel</ButtonSecondary>
				<ButtonWarning onClick={onDetachHandle} submittable={!isUpdateModelNumberCategoriesPending}>
					Yes, detach
				</ButtonWarning>
			</div>
		</Modal>
	)
}
